// UI labels only: retain original action names, selectors and document values.
const editorLabels: Readonly<Record<string, string>> = {
  Add: 'Adicionar',
  'Add filter': 'Adicionar filtro',
  'Add filter group': 'Adicionar grupo de filtros',
  'Add sort': 'Adicionar ordenação',
  Align: 'Alinhamento',
  'Align center': 'Centralizar',
  'Align left': 'Alinhar à esquerda',
  'Align right': 'Alinhar à direita',
  And: 'E',
  Attachment: 'Anexo',
  Background: 'Fundo',
  'Background color': 'Cor de fundo',
  Basic: 'Básico',
  Blue: 'Azul',
  Bold: 'Negrito',
  'Bulleted List': 'Lista com marcadores',
  BulletedList: 'Lista com marcadores',
  Calendar: 'Calendário',
  'Calendar View': 'Visualização em calendário',
  'Calendar by': 'Calendário por',
  Callout: 'Destaque',
  CheckBox: 'Caixa de seleção',
  Checkbox: 'Caixa de seleção',
  'Clear column contents': 'Limpar conteúdo da coluna',
  'Clear column style': 'Limpar estilo da coluna',
  'Clear contents': 'Limpar conteúdo',
  'Clear row contents': 'Limpar conteúdo da linha',
  'Clear row style': 'Limpar estilo da linha',
  Code: 'Código',
  'Code Block': 'Bloco de código',
  CodeBlock: 'Bloco de código',
  CollapseTab: 'Diminuir recuo',
  Color: 'Cor',
  Colors: 'Cores',
  Comment: 'Comentar',
  'Connect calendar': 'Conectar calendário',
  Connector: 'Conector',
  'Content & Media': 'Conteúdo e mídia',
  'Edgeless Element': 'Elementos do quadro branco',
  Style: 'Estilo',
  Copy: 'Copiar',
  'Create date property': 'Criar propriedade de data',
  'Created Time': 'Data de criação',
  Curve: 'Curva',
  Custom: 'Personalizado',
  Dark: 'Escuro',
  Database: 'Base de dados',
  Date: 'Data',
  'Date by': 'Data por',
  'Date range': 'Intervalo de datas',
  Default: 'Padrão',
  'Default Color': 'Cor padrão',
  Delete: 'Excluir',
  'Delete Card': 'Excluir cartão',
  'Delete Cards': 'Excluir cartões',
  'Delete Database': 'Excluir base de dados',
  'Delete Row': 'Excluir linha',
  'Delete Rows': 'Excluir linhas',
  'Delete view': 'Excluir visualização',
  Divider: 'Separador',
  'Document Group&Frame': 'Grupos e quadros do documento',
  Duplicate: 'Duplicar',
  'Duplicate view': 'Duplicar visualização',
  'Edgeless content': 'Conteúdo da tela livre',
  'Edgeless shape': 'Forma da tela livre',
  'Edit View': 'Editar visualização',
  Elbowed: 'Angular',
  Embed: 'Incorporar',
  'Embed block': 'Bloco incorporado',
  Embeds: 'Incorporações',
  'End Date': 'Data final',
  'End date': 'Data final',
  Equation: 'Equação',
  'Expand Card': 'Expandir cartão',
  'Expand Row': 'Expandir linha',
  'External calendars': 'Calendários externos',
  Filter: 'Filtrar',
  Frame: 'Quadro',
  'Frame block': 'Bloco de quadro',
  Green: 'Verde',
  Grey: 'Cinza',
  Group: 'Agrupar',
  'Group By': 'Agrupar por',
  'Heading 1': 'Título 1',
  'Heading 2': 'Título 2',
  'Heading 3': 'Título 3',
  'Heading 4': 'Título 4',
  'Heading 5': 'Título 5',
  'Heading 6': 'Título 6',
  'Hide In View': 'Ocultar nesta visualização',
  'Hide empty groups': 'Ocultar grupos vazios',
  'Hide toolbar': 'Ocultar barra de ferramentas',
  Image: 'Imagem',
  'Image block': 'Bloco de imagem',
  Import: 'Importar',
  'Inline equation': 'Equação no texto',
  InlineTex: 'Equação no texto',
  'Insert Above': 'Inserir acima',
  'Insert After': 'Inserir depois',
  'Insert Before': 'Inserir antes',
  'Insert Below': 'Inserir abaixo',
  'Insert Left': 'Inserir à esquerda',
  'Insert Left Column': 'Inserir coluna à esquerda',
  'Insert Right': 'Inserir à direita',
  'Insert Right Column': 'Inserir coluna à direita',
  Italic: 'Itálico',
  'Kanban View': 'Visualização em quadro',
  'Kanban view': 'Visualização em quadro',
  Light: 'Claro',
  'Link to Doc': 'Vincular a documento',
  'Linked Doc': 'Documento vinculado',
  LinkedPage: 'Documento vinculado',
  List: 'Lista',
  'Mind Map': 'Mapa mental',
  'Mind map': 'Mapa mental',
  'Move Down': 'Mover para baixo',
  'Move Left': 'Mover para a esquerda',
  'Move Right': 'Mover para a direita',
  'Move To': 'Mover para',
  'Move Up': 'Mover para cima',
  'Multi-select': 'Seleção múltipla',
  'New Doc': 'Novo documento',
  NewPage: 'Novo documento',
  'Newest first': 'Mais recentes primeiro',
  None: 'Nenhum',
  Note: 'Nota',
  'Note block': 'Bloco de nota',
  Now: 'Agora',
  Number: 'Número',
  'Number Format': 'Formato numérico',
  'Numbered List': 'Lista numerada',
  NumberedList: 'Lista numerada',
  'Oldest first': 'Mais antigos primeiro',
  Or: 'Ou',
  Orange: 'Laranja',
  'Other Headings': 'Outros títulos',
  Page: 'Página',
  Paste: 'Colar',
  Pen: 'Caneta',
  'Plain-Text': 'Texto simples',
  Progress: 'Progresso',
  Properties: 'Propriedades',
  Purple: 'Roxo',
  Quote: 'Citação',
  Red: 'Vermelho',
  Redo: 'Refazer',
  'Remove Grouping': 'Remover agrupamento',
  'Remove grouping': 'Remover agrupamento',
  RightTab: 'Aumentar recuo',
  Select: 'Selecionar',
  Shape: 'Forma',
  'Show all workspace calendars': 'Mostrar todos os calendários do espaço',
  Sort: 'Ordenar',
  'Sort Ascending': 'Ordenar em ordem crescente',
  'Sort Descending': 'Ordenar em ordem decrescente',
  'Start week on': 'Início da semana',
  Straight: 'Reto',
  StrikeThrough: 'Tachado',
  Strikethrough: 'Tachado',
  Table: 'Tabela',
  'Table View': 'Visualização em tabela',
  'Table view': 'Visualização em tabela',
  Tags: 'Marcadores',
  Teal: 'Verde-azulado',
  Template: 'Modelo',
  Text: 'Texto',
  Title: 'Título',
  'To-do List': 'Lista de tarefas',
  Today: 'Hoje',
  Todo: 'A fazer',
  Tomorrow: 'Amanhã',
  'Turn into': 'Converter em',
  Type: 'Tipo',
  UnderLine: 'Sublinhado',
  Underline: 'Sublinhado',
  Undo: 'Desfazer',
  Ungroup: 'Desagrupar',
  White: 'Branco',
  Yellow: 'Amarelo',
  Yesterday: 'Ontem',
  Actions: 'Ações',
  Media: 'Mídia',
  Formatting: 'Formatação',
  Hand: 'Mover tela',
};

export function localizeEditorLabel(label: string): string {
  return Object.hasOwn(editorLabels, label) ? editorLabels[label] : label;
}
